<template>
  <div class="present">
    <figure class="present-thumbnail">
      <div class="thumbnail">
        <img
          :src="present.thumbnail"
          :alt="present.name"
        >
      </div>
    </figure>
    <div class="present-detail">
      <div class="present-name">
        <Title>
          <template #title>
            {{ present.name }}
          </template>
        </Title>
      </div>
      <div class="sub-text">
        {{ present.num }}
      </div>
      <div class="sub-text2">
        {{ present.day }}
      </div>
      <p
        v-html="present.description"
      />
      <div class="presented-by">
        <span>
          {{ present.company }}
        </span>
        <a
          :href="present.url"
          target="_blank">
          {{ present.url }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/atoms/Title.vue'
export default {
  props: {
    present: {
      type: Object,
      required: true
    }
  },
  components: {
    Title
  }
}
</script>

<style lang="sass" scoped>
.present
  background-color: #fff
  border-radius: 8px
  overflow: hidden
  box-shadow: 0 2px 8px rgba(0, 0, 0, .2)
  .present-name /deep/
    .title
      display: block
      h2
        display: inline
        line-height: 1.6
        margin-right: 10px
  .present-detail
    padding: 15px
    .sub-text
      display: inline-block
      color: #fff
      background-color: $green
      padding: 4px 10px
      border-radius: 20px
      font-size: 1.4rem
      max-width: 100px
      text-align: center
    .sub-text2
      display: inline-block
      color: #fff
      background-color: $poppink
      padding: 4px 10px
      border-radius: 20px
      font-size: 1.4rem
      max-width: 200px
      text-align: center
      margin-left: 10px
    p
      margin-top: 10px
      text-align: justify
      line-height: 1.6
      font-size: 1.4rem
  .presented-by
    display: flex
    flex-direction: column
    margin-top: 10px
    line-height: 1.6
    font-size: 1.4rem
    span
      font-weight: bold
    a
      color: $blue
      text-decoration: underline
</style>
